import { type ReactNode, useCallback } from "react";

import { TwoFaConnector } from "@features/two-fa/two-fa-connector";
import { useNavigate } from "@tanstack/react-router";

import { Route as KybVerifyFaRoute } from "@app/navigation/routes/_private/kyb-verify";
import { Route as KycVerifyFaRoute } from "@app/navigation/routes/_private/kyc-verify";
import { Route as PhoneVerifyRoute } from "@app/navigation/routes/_private/phone-verify";
import { Route as PoliciesAgreementRoute } from "@app/navigation/routes/_private/policies-agreement";
import { Route as PublicOfferRoute } from "@app/navigation/routes/_private/public-offer";
import { Route as QuestionnaireAgreementRoute } from "@app/navigation/routes/_private/questionnaire-agreement";
import { Route as TwoFaVerifyRoute } from "@app/navigation/routes/_private/two-fa-verify";

type Props = {
  children: ReactNode;
};

export const TwoFaGuard = ({ children }: Props) => {
  const navigate = useNavigate();

  const handleGoToTwoFaVerify = useCallback(async () => {
    await navigate({
      to: TwoFaVerifyRoute.fullPath,
    });
  }, [navigate]);

  const handleGoToKycVerify = useCallback(async () => {
    await navigate({
      to: KycVerifyFaRoute.fullPath,
    });
  }, [navigate]);

  const handleGoToPhoneVerify = useCallback(async () => {
    await navigate({
      to: PhoneVerifyRoute.fullPath,
    });
  }, [navigate]);

  const handleGoToKybVerify = useCallback(async () => {
    await navigate({
      to: KybVerifyFaRoute.fullPath,
    });
  }, [navigate]);

  const handleGoToPolicies = useCallback(async () => {
    await navigate({
      to: PoliciesAgreementRoute.fullPath,
    });
  }, [navigate]);

  const handleGoToOffer = useCallback(async () => {
    await navigate({
      to: PublicOfferRoute.fullPath,
    });
  }, [navigate]);

  const handleGoToQuestionnaire = useCallback(async () => {
    await navigate({
      to: QuestionnaireAgreementRoute.fullPath,
    });
  }, [navigate]);

  return (
    <TwoFaConnector
      onGoToKybVerify={handleGoToKybVerify}
      onGoToKycVerify={handleGoToKycVerify}
      onGoToOffer={handleGoToOffer}
      onGoToPhoneVerify={handleGoToPhoneVerify}
      onGoToPolicies={handleGoToPolicies}
      onGoToQuestionnaire={handleGoToQuestionnaire}
      onGoToTwoFaVerify={handleGoToTwoFaVerify}
    >
      {children}
    </TwoFaConnector>
  );
};
